// import moment from 'moment'
import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './assets.jade'
import { TeamSource, Team, Match, Season} from '../../models'
import { sports } from '@scoutgg/scoring-rules'

// import query from '../../services/query'
import config from '@scoutgg/ftw/source/services/config'
import notify from '@scoutgg/ftw/source/services/notification'
import '@scoutgg/ftw/source/atoms/tabs/tabs'
import '../seasons'
import '@scoutgg/ftw/source/atoms/scroll/scroll'
import '@scoutgg/ftw/source/molecules/gameweeks/gameweeks'

const sortables = {
  name: (a, b) => (a.name || '').localeCompare(b.name),
  season: (a, b) => a.season - b.season,
}

@Component('sporty')
@Template(template)
@Attribute('season', Season)
@Attribute('order', Boolean)
@Attribute('sport', String)

export default class Assets extends HTMLElement {
  attached() {
    this.defaultProperty
    this.update(Season.load({ visibility: 'all' }))
  }


  sortIcon(column) {
    if (this.sort !== column) {
      return 'ui--table_sort'
    } else if (this.order) {
      return 'ui--table_sorted_down'
    } else {
      return 'ui--table_sorted_up'
    }
  }
  sortBy(column) {
    if (this.sort === column) {
      this.order = !this.order
    } else {
      this.order = true
      this.sort = column
    }
  }

  get defaultProperty() {
      if (!this.tab) this.tab = 'seasons'
      if (!this.sport) this.sport = sports[0]
      if (!this.sort) {
        this.sort = "name"
        this.order = false
      }
  }

  get tabContexts() {
    return [
      'seasons',
      'teams',
    ]
  }
  get tabText() {
    return {
      'teams':'add Teams',
      'seasons':'Leagues Logo',
    }

  }


  get sortedSeasons() {
    const reversed = this.order ? -1 : 1
    return this.seasons.filter(item=> item.sport === this.sport).sort((a, b) => {
      return (sortables[this.sort](a, b, this) || sortables.season(a, b)) * reversed
    })
  }
  get sports() {
    return sports.sort()
  }

  setTab(tab) {
    this.tab = tab
    this.render()
  }

  setSport(sport) {
    this.sport = sport
  }

  setSeason(season) {
    this.season = season
    this.loadTeams()
  }

  loadTeams() {
    if (!this.season) return
    var params = {
      $reload: true,
      season: this.season._id,
    }
    return TeamSource.load(params).then((data) => {
      this.teams = data.teams
      this.$cached = null
      this.render()
    })


  }

  hasShirt(realTeam) {
    return !!realTeam.shirtId
  }

  uploadImg(e) {
    let el = e.target
    let file = el.parentNode.querySelector('input[type="file"]').files[0]
    let form = el.parentNode
    let season = Season.instance(el.dataset.season)
    let team = Team.instance(el.dataset.team)

    var formData = new FormData()
    formData.append("file", file)
    let url = `api/seasons/${season._id}/upload-icon`
    if ((this.tab === 'teams') && team && team._id !== "-1") url = `api/teams/${team._id}/upload-icon`

    if (!file) return

    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        authorization: `Bearer sportyman ${config.token}`,
      },
    }).then(
      response => {
        response.json()
      } // if the response is a JSON object
    ).then(
      success => {
        notify('Images uploaded', { level: 'success', timeout: 5000 })
      } // Handle the success response object
    ).catch(
      error => notify(`Error ${error}`, { level: 'danger', timeout: 10000 }) // Handle the error response object
    )
  }

  get SCROLL_RIGHT() {
    return -1
  }

  get SCROLL_LEFT() {
    return 1
  }

  next() {
    this.scrollToSide(this.SCROLL_RIGHT)
  }

  prev() {
    this.scrollToSide(this.SCROLL_LEFT)
  }
  scrollToSide(side) {
    if (!this.iScrollNode) return
    this.newSport(side)
    let activedSport = this.sports
    this.iScrollNode.iscroll.scrollBy(this._scrollVector(side, 100), 0, 500)
  }

  _scrollVector(side, scrollNode) {
    let items = Array.from(this.shadowRoot.querySelectorAll('.sports-item'))
    let widthItem = items[0].offsetWidth
    let vector = scrollNode.x + side * (widthItem - widthItem / 2)
    if (
      (side < 0 && vector <= scrollNode.maxScrollX) ||
      (side > 0 && vector >= 0)
    ) {
      widthItem = 50
    }
    return side * widthItem
  }
  get iScrollNode() {
    var scrollElement = this.shadowRoot.querySelector('i-scroll')
    if (!scrollElement) return null
    return scrollElement
  }
  newSport(side) {
    let index = this.sports.indexOf(this.sport)
    let newIndex = (side === 1) ? --index : ++index
    if (newIndex === -1) newIndex = 0
    if (newIndex > this.sports.length - 1) newIndex = this.sports.length - 1
    this.sport = this.sports[newIndex]
  }
}
